export const MOVE_IN_TOO_SOON = "MOVE_IN_TOO_SOON";

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export type MoveInTooSoonInfo = {
  message: string;
  earliestMoveInDate: string;
};

// RTK Query errors are `{ status, data }`. The API returns either
// `{ message, code, earliestMoveInDate }` (route catch) or
// `{ err, message, code, earliestMoveInDate }` (app.ts global handler).
export function parseMoveInTooSoonError(
  error: unknown
): MoveInTooSoonInfo | null {
  const envelope = error as
    | { data?: Record<string, unknown> }
    | Record<string, unknown>
    | null;
  const data =
    envelope &&
    typeof envelope === "object" &&
    "data" in envelope &&
    envelope.data
      ? (envelope.data as Record<string, unknown>)
      : (envelope as Record<string, unknown> | null);
  if (!data || typeof data !== "object") return null;
  const code = data.code;
  const earliest = data.earliestMoveInDate;
  if (
    code !== MOVE_IN_TOO_SOON ||
    typeof earliest !== "string" ||
    !ISO_DATE.test(earliest)
  ) {
    return null;
  }
  const message =
    (typeof data.message === "string" && data.message) ||
    (typeof data.err === "string" && data.err) ||
    "";
  return { message, earliestMoveInDate: earliest };
}
